/* eslint-disable */

import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// Import Images
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar4 from "assets/images/users/avatar-4.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import avatar6 from "assets/images/users/avatar-6.jpg";
import avatar7 from "assets/images/users/avatar-7.jpg";
import avatar8 from "assets/images/users/avatar-8.jpg";
import avatar9 from "assets/images/users/avatar-9.jpg";
import avatar10 from "assets/images/users/avatar-10.jpg";
import { getAuthCookie } from "../../utils/authCookies";

const todoTaskList = [
  {
    id: "1",
    task: "Added Select2",
    subItem: [
      {
        img: avatar1,
      },
      {
        img: avatar3,
      },
    ],
    dueDate: "25 Jan, 2022",
    status: "Pending",
    priority: "High",
  },
  {
    id: "2",
    task: "Additional Calendar",
    subItem: [
      {
        img: avatar5,
      },
      {
        img: avatar9,
      },
      {
        img: avatar10,
      },
    ],
    dueDate: "23 Apr, 2022",
    status: "Completed",
    priority: "Medium",
  },
  {
    id: "3",
    task: "Add Dynamic Contact List",
    subItem: [
      {
        img: avatar5,
      },
      {
        img: avatar6,
      },
      {
        img: avatar7,
      },
      {
        img: avatar8,
      },
    ],
    dueDate: "24 Apr, 2022",
    status: "Inprogress",
    priority: "Low",
  },
  {
    id: "4",
    task: "Brand Logo design",
    subItem: [
      {
        img: avatar2,
      },
      {
        img: avatar10,
      },
      {
        img: avatar9,
      },
    ],
    dueDate: "25 Apr, 2022",
    status: "New",
    priority: "Medium",
  },
  {
    id: "5",
    task: "Change email option process",
    subItem: [
      {
        img: avatar3,
      },
      {
        img: avatar10,
      },
      {
        img: avatar9,
      },
    ],
    dueDate: "25 Apr, 2022",
    status: "Completed",
    priority: "High",
  },
  {
    id: "6",
    task: "Make a creating an account profile",
    subItem: [
      {
        img: avatar3,
      },
    ],
    dueDate: "26 Apr, 2022",
    status: "Completed",
    priority: "Medium",
  },
  {
    id: "7",
    task: "Profile Page Structure",
    subItem: [
      {
        img: avatar4,
      },
      {
        img: avatar5,
      },
    ],
    dueDate: "27 Apr, 2022",
    status: "New",
    priority: "Low",
  },
  {
    id: "8",
    task: "Datatable with jQuery cdn",
    subItem: [
      {
        img: avatar6,
      },
      {
        img: avatar7,
      },
      {
        img: avatar8,
      },
    ],
    dueDate: "28 Apr, 2022",
    status: "Pending",
    priority: "High",
  },
  {
    id: "9",
    task: "Added File Manager Apps",
    subItem: [
      {
        img: avatar3,
      },
      {
        img: avatar4,
      },
      {
        img: avatar5,
      },
    ],
    dueDate: "29 Apr, 2022",
    status: "Completed",
    priority: "Medium",
  },
  {
    id: "10",
    task: "Added Back to Top button",
    subItem: [
      {
        img: avatar6,
      },
      {
        img: avatar7,
      },
    ],
    dueDate: "30 Apr, 2022",
    status: "Inprogress",
    priority: "High",
  },
  {
    id: "11",
    task: "Added bdge new style - gradient",
    subItem: [
      {
        img: avatar3,
      },
      {
        img: avatar10,
      },
      {
        img: avatar9,
      },
    ],
    dueDate: "01 May, 2022",
    status: "Inprogress",
    priority: "Medium",
  },
  {
    id: "12",
    task: "Added new tabs styles",
    subItem: [
      {
        img: avatar2,
      },
    ],
    dueDate: "01 May, 2022",
    status: "New",
    priority: "Low",
  },
  {
    id: "13",
    task: "Make a creating an account profile",
    subItem: [
      {
        img: avatar5,
      },
      {
        img: avatar6,
      },
      {
        img: avatar7,
      },
      {
        img: avatar8,
      },
    ],
    dueDate: "02 May, 2022",
    status: "Completed",
    priority: "Low",
  },
  {
    id: "14",
    task: "Additional Mailbox",
    subItem: [
      {
        img: avatar5,
      },
      {
        img: avatar9,
      },
      {
        img: avatar10,
      },
    ],
    dueDate: "02 Apr, 2022",
    status: "Pending",
    priority: "Medium",
  },
  {
    id: "15",
    task: "Added Email Templates",
    subItem: [
      {
        img: avatar1,
      },
      {
        img: avatar3,
      },
    ],
    dueDate: "03 Apr, 2022",
    status: "Inprogress",
    priority: "High",
  },
];


const todoCollapse = [
  {
    id: 1,
    title: "Velzon Admin & Dashboard",
    subItem: [
      { id: 1, version: "v1.4.0", iconClass: "danger" },
      { id: 2, version: "v1.5.0", iconClass: "secondary" },
      { id: 3, version: "v1.6.0", iconClass: "info" },
      { id: 4, version: "v1.7.0", iconClass: "primary" },
      { id: 5, version: "v1.8.0", iconClass: "warning" },
    ],
  },
  {
    id: 2,
    title: "Project Management",
    subItem: [
      { id: 1, version: "v2.1.0", iconClass: "danger" },
      { id: 2, version: "v2.2.0", iconClass: "secondary" },
      { id: 3, version: "v2.3.0", iconClass: "info" },
      { id: 4, version: "v2.4.0", iconClass: "primary" },
    ],
  },
  {
    id: 3,
    title: "Skote Admin & Dashboard",
    subItem: [
      { id: 1, version: "v4.1.0", iconClass: "danger" },
      { id: 2, version: "v4.2.0", iconClass: "secondary" },
    ],
  },
  {
    id: 4,
    title: "Doot - Chat App Template",
    subItem: [
      { id: 1, version: "v1.0.0", iconClass: "danger" },
      { id: 2, version: "v1.1.0", iconClass: "secondary" },
      { id: 2, version: "v1.2.0", iconClass: "info" },
    ],
  },
];

// export { todoTaskList, todoCollapse };


const SignageTodoList = () => {
    const editEvent = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        // Add your event editing logic here
        console.log("Edit event clicked");
    };
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState<string | null>(null);
    const token = getAuthCookie("sessionToken");
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className="content">
            <div className="card">
                <div className="card-body">
                    
                    <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
                        <div className="file-manager-sidebar minimal-border">
                            <div className="p-4 d-flex flex-column h-100">
                                <div className="mb-3">
                                    <button className="btn btn-success w-100" data-bs-target="#createProjectModal" data-bs-toggle="modal"><i className="ri-add-line align-bottom"></i> Add Project</button>
                                </div>

                                <div className="px-4 mx-n4" data-simplebar style={{ height: "calc(100vh - 468px)" }}>
                                    <ul className="to-do-menu list-unstyled" id="projectlist-data">
                                        <li>
                                            <a data-bs-toggle="collapse" href="#velzonAdmin" className="nav-link fs-13 active">Velzon Admin & Dashboard</a>
                                            <div className="collapse show" id="velzonAdmin">
                                                <ul className="mb-0 sub-menu list-unstyled ps-3 vstack gap-2 mb-2">
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-danger"></i> v1.4.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-secondary"></i> v1.5.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-info"></i> v1.6.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-primary"></i> v1.7.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-warning"></i> v1.8.0</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <a data-bs-toggle="collapse" href="#projectManagement" className="nav-link fs-13">Project Management</a>
                                            <div className="collapse" id="projectManagement">
                                                <ul className="mb-0 sub-menu list-unstyled ps-3 vstack gap-2 mb-2">
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-danger"></i> v2.1.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-secondary"></i> v2.2.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-info"></i> v2.3.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-primary"></i> v2.4.0</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <a data-bs-toggle="collapse" href="#skoteAdmin" className="nav-link fs-13">Skote Admin & Dashboard</a>
                                            <div className="collapse" id="skoteAdmin">
                                                <ul className="mb-0 sub-menu list-unstyled ps-3 vstack gap-2 mb-2">
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-danger"></i> v4.1.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-secondary"></i> v4.2.0</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <a data-bs-toggle="collapse" href="#ecommerceProject" className="nav-link fs-13">Doot - Chat App Template</a>
                                            <div className="collapse" id="ecommerceProject">
                                                <ul className="mb-0 sub-menu list-unstyled ps-3 vstack gap-2 mb-2">
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-danger"></i> v1.0.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-secondary"></i> v1.1.0</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!"><i className="ri-stop-mini-fill align-middle fs-15 text-info"></i> v1.2.0</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>


                                <div className="mt-auto text-center">
                                    <img src="/assets/images/task.png" alt="Task" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="file-manager-content minimal-border w-100 p-4 pb-0">
                            <div className="row mb-4">
                                <div className="col-auto order-1 d-block d-lg-none">
                                    <button type="button" className="btn btn-soft-success btn-icon btn-sm fs-16 file-menu-btn">
                                        <i className="ri-menu-2-fill align-bottom"></i>
                                    </button>
                                </div>
                                <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                                    <h5 className="fw-semibold mb-0">To do list </h5>
                                </div>

                                <div className="col-auto order-2 order-sm-3 ms-auto">
                                    <div className="hstack gap-2">
                                        <div className="btn-group" role="group" aria-label="Basic example">
                                            <button className="btn btn-icon fw-semibold btn-soft-danger material-shadow-none"><i className="ri-arrow-go-back-line"></i></button>
                                            <button className="btn btn-icon fw-semibold btn-soft-success material-shadow-none"><i className="ri-arrow-go-forward-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3 bg-light rounded mb-4">
                                <div className="row g-2">
                                    <div className="col-lg-auto">
                                        <select className="form-control" data-choices data-choices-search-false name="choices-select-sortlist" id="choices-select-sortlist">
                                            <option value="">Sort</option>
                                            <option value="By ID">By ID</option>
                                            <option value="By Name">By Name</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-auto">
                                        <select className="form-control" data-choices data-choices-search-false name="choices-select-status" id="choices-select-status">
                                            <option value="">All Tasks</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Inprogress">Inprogress</option>
                                            <option value="Pending">Pending</option>
                                            <option value="New">New</option>
                                        </select>
                                    </div>
                                    <div className="col-lg">
                                        <div className="search-box" style={{marginTop:"5px"}}>
                                            <input type="text" id="searchTaskList" className="form-control search" placeholder="Search task name" />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>
                                    <div className="col-lg-auto">
                                        <button className="btn btn-primary createTask" type="button" data-bs-toggle="modal" data-bs-target="#createTask">
                                            <i className="ri-add-fill align-bottom"></i> Add Tasks
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="todo-content position-relative px-4 mx-n4" id="todo-content">
                                <div id="elmLoader">
                                    <div className="spinner-border text-primary avatar-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                <div className="todo-task" id="todo-task">
                                    <div className="table-responsive">
                                        <table className="table align-middle position-relative table-nowrap">
                                            <thead className="table-active">
                                                <tr>
                                                    <th scope="col">Task Name</th>
                                                    <th scope="col">Assigned</th>
                                                    <th scope="col">Due Date</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Priority</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody id="task-list">
                                                {todoTaskList?.map((task, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="d-flex align-items-start">
                                                                <div className="flex-shrink-0 me-3">
                                                                    <div className="task-handle px-1 bg-light rounded">: :</div>
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" value="15" id="todo15" />{" "}
                                                                        <label className="form-check-label" htmlFor="todo15"> {task?.task}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="avatar-group flex-nowrap">
                                                                <a href="javascript: void(0);" className="avatar-group-item" data-img="/assets/images/users/avatar-1.jpg" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Curtis Saenz">
                                                                    <img src="/assets/images/users/avatar-1.jpg" alt="" className="rounded-circle avatar-xxs" />
                                                                </a>
                                                                <a href="javascript: void(0);" className="avatar-group-item" data-img="assets/images/users/avatar-3.jpg" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="John Robles">
                                                                    <img src="/assets/images/users/avatar-3.jpg" alt="" className="rounded-circle avatar-xxs" />
                                                                </a>
                                                            </div>
                                                        </td>
                                                        <td>{task?.dueDate}</td>
                                                        <td>
                                                            {task?.status === 'Pending' ? (
                                                                <span className="badge bg-warning-subtle text-warning text-uppercase">{task?.status}</span>
                                                            ) : task?.status === 'Completed' ? (
                                                                <span className="badge bg-success-subtle text-success text-uppercase">{task?.status}</span>
                                                            ) : task?.status === 'Inprogress' ? (
                                                                <span className="badge bg-info-subtle text-info text-uppercase">{task?.status}</span>
                                                            ) : task?.status === 'New' ? (
                                                                <span className="badge bg-primary-subtle text-primary text-uppercase">{task?.status}</span>
                                                            ) : null}
                                                            
                                                        </td>
                                                        <td>
                                                            {task?.priority === 'High' ? (
                                                                <span className="badge bg-danger text-uppercase">{task?.priority}</span>
                                                            ) : task?.priority === 'Medium' ? (
                                                                <span className="badge bg-warning text-uppercase">{task?.priority}</span>
                                                            ) : task?.priority === 'Low' ? (
                                                                <span className="badge bg-success text-uppercase">{task?.priority}</span>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            <div className="hstack gap-2">
                                                                <button className="btn btn-sm btn-soft-danger remove-list" data-bs-toggle="modal" data-bs-target="#removeTaskItemModal" data-remove-id="15"><i className="ri-delete-bin-5-fill align-bottom"></i></button>
                                                                <button className="btn btn-sm btn-soft-info edit-list" data-bs-toggle="modal" data-bs-target="#createTask" data-edit-id="15"><i className="ri-pencil-fill align-bottom"></i></button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="py-4 mt-4 text-center" id="noresult" style={{ display: "none" }}>
                                    <h5 className="mt-4">Sorry! No Result Found</h5>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignageTodoList;
